import React,{useState,useEffect} from 'react';
import {TableDatePicker,btnSetColor_CBack,btnSetColorDirect_CBack} from '../function_lib/common_lib';
import {FileUploaderV1} from '../function_lib/upload_lib_file';
import  {Multi_Member_Edit_Form} from './multi_member_edit_form';

import './comp_form_digital_seva_new.css';
export const Comp_Edit_Form_Digital_New=(props)=>{
  const [members, setMembers] = useState([{}]);
    const addRequestForm=()=>{
      //alert("i min click");
      btnSetColorDirect_CBack(this,"frmEditNewRequestDigital","editMultiReqForm",function(data,msg){
          if(data==="001"){
            alert(msg);
            window.location.reload();
          }else{
            alert(msg);
          }
        })
    }

    useEffect(()=>{
       // alert(JSON.stringify(props.profileData));
      //alert(JSON.stringify(props.formFields));

      if (props.profileData?.form_request) {
        try {
          const parsed = JSON.parse(props.profileData.form_request);
          //alert(parsed);
          if (Array.isArray(parsed)) {
            setMembers(parsed); // load all members
          }
        } catch (e) {
          console.log("Invalid JSON");
        }
      }

      FileUploaderV1(this,function(data,msg){
       //alert("i m done");
      });
    },[props.profileData])
    return(<div className="modal fade modal-xl11" id="divEditFromDigitalSevaNew" tabindex="-1" role="dialog">
    
        <div className="modal-dialog modal-xl11" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    
                    <button type="button" className="close" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">x</span></button>
                </div>
                {props.compUser.length>0 && members.length>0?<>
                <div className="modal-body" style={{"justify-content":"center",
    "align-items": "center"}}>
      <div id="respDigiSeva" name="respDigiSeva"></div>
                <div id="shiiping_add" style={{"width":"100%","margin":"auto"}}>
                               
                               {/* <h3>{props.formFields[0]["category_name"]}</h3> */}
                               <form id="frmEditNewRequestDigital" name="frmEditNewRequestDigital">
                               
                               <input type='hidden' name="m_type" id="m_type" value={"editMultiReqForm"} />
                               <input type='hidden' name="m_type" id="m_type" value={"editMultiReqForm"} />
                               <input type='hidden' name="res_func" id="res_func" value={"resnuse"}/>
                               <input type="hidden" name="ref_form_category" id="ref_form_category" value={btoa(props.profileData["category_master_id"])} />
                               <input  type='hidden'  name="loc_token" id="loc_token" value={props.compUser[0].id}/>
                               <input type='hidden' name="member_request_id" id="member_request_id" value={btoa(props.profileData["id"])}/>
                               
                            <input type="hidden" name="lsVideo" id="lsVideo"/>
                            <input type="hidden" name="lsPdf" id="lsPdf"/>
                               <div class="digital-seva-point-new-form">
         
      <div class="row">
        <div class="col-md-8">

        
          <div class="progress-strip mb-4">
            <div class="p-step active">
              <div class="p-num">1</div>
              <div class="p-label">{members[0]["category_name"]}</div>
            </div>
           
          </div>

          

         
            <div class="section-card">
                <div class="sh-line"></div>
              
              
                

                {members.map((item, index) => (
        <Multi_Member_Edit_Form
          key={index}
          index={index}
          formFields={members[index]}
          onRemove={() => {
            const updated = [...members];
            updated.splice(index, 1);
            setMembers(updated);
          }}
        />
      ))}
              
                  
                
              

              <div class="fields-body">
                {/* {members.length>0 && props.formFields.length>0?
              <button
        type="button"
        className="btn btn-submit btn-danger mt-3"
        onClick={() => setMembers([...members, [...props.formFields]])}
      >
        + Add New Form
      </button>:''} */}
              </div>
            
              <div class="fields-body">
              
                <div class="form-group">
                  <div class="col-12">
                  <label class="flabel">Feedback </label>
                  <textarea class="f-input f-textarea" rows="3" placeholder="Enter form requirements here"></textarea>
                </div>
                </div>
              </div>
            </div>

        
            <div class="submit-strip">
              <button type="button" onClick={()=>addRequestForm()} class="btn-submit _btnSetColor11">Submit Application</button>
              <button type="reset" class="btn-reset">Reset</button>
            </div>

          
        </div>

        {/* <div class="col-md-4 sidebar">
          <div class="pay-card">
            <div class="pay-head">
              <span class="pay-head-title">Payment Summary</span>
              <div class="pay-head-lock">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                Secure
              </div>
            </div>

            <div class="pay-items">
              <div class="pi-row">
                <a href="#" class="pi-link">Basic PAN Card Service</a>
                <span class="pi-amount">₹ 107</span>
              </div>
              <div class="pi-row">
                <a href="#" class="pi-link">Convenience Charges</a>
                <span class="pi-amount">₹ 20</span>
              </div>
            </div>

            <div class="pay-opts">
              <div class="opt-row">
                <label class="opt-label">
                  <input type="checkbox"/> 175 Rs/- for DSA CATEGORY
                </label>
                <span class="opt-amt">₹ 175</span>
              </div>
              <div class="opt-row">
                <label class="opt-label">
                  <input type="checkbox"/> 167 Rs/- for PCO CATEGORY
                </label>
                <span class="opt-amt">₹ 167</span>
              </div>
              <div class="opt-row">
                <label class="opt-label">
                  <input type="checkbox"/> 50 Rs/- for CATEGORY 02
                </label>
                <span class="opt-amt">₹ 50</span>
              </div>
              <div class="opt-row">
                <label class="opt-label">
                  <input type="checkbox"/> 100 Rs/- for CATEGORY 03
                </label>
                <span class="opt-amt">₹ 100</span>
              </div>
            </div>

            <div class="pay-total">
              <span class="pt-label">Total Amount</span>
              <span class="pt-amount">₹ 127</span>
            </div>

            <div class="pay-foot">
              <div class="opt-row" style={{marginBottom:'10px'}}>
                <label class="opt-label">
                  <input type="checkbox"/> Use Reward Points
                </label>
                <span class="opt-amt">₹ 8.00</span>
              </div>
              <div class="terms-check">
                <input type="checkbox"/>
                <span>I accept the <a href="#">Terms of Use</a> &amp; <a href="#">Privacy Policy</a></span>
              </div>
              <button class="btn-pay">Proceed &amp; Pay - ₹ 127</button>
              <button class="btn-cart">Add to Cart</button>
            </div>
          </div>

        </div> */}

      </div>
      </div>
                               </form>
                              
                               </div>
                </div></>:''}
            </div>
        </div>
        </div>)

}
export default Comp_Edit_Form_Digital_New;